// extracted by mini-css-extract-plugin
module.exports = {"tag-name":"i_Dd"};